import { useFormik } from "formik";
import { convertToFilter, makeObservable } from "../../../util";
import { useEffect } from "react";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

const reservationFilterStore = makeObservable({});
const reservationNavigationStore = createSearchResultNavigationStore();

const useReservationFilters = () => {
  const formik = useFormik({
    initialValues: {
      categoryId: "",
      type: { operator: "in" },
    },
  });

  const filterKeys = [];

  const skipKeys = ["limit", "offset"];

  useEffect(() => {
    reservationFilterStore.set(
      convertToFilter({ values: formik.values, filterKeys, skipKeys }),
    );
  }, [formik.values]);

  return {
    formik,
  };
};

export {
  reservationFilterStore,
  reservationNavigationStore,
  useReservationFilters,
};
